/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SalesforceReferenceInfo } from '../models';
/**
 * CallTargetSfReferenceInfoApi - axios parameter creator
 * @export
 */
export const CallTargetSfReferenceInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CallTargetのSF参照値の取得
         * @summary CallTargetのSF参照値の取得
         * @param {number} callTargetId CallTargetID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallTargetSfReferenceInfo: async (callTargetId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callTargetId' is not null or undefined
            assertParamExists('getCallTargetSfReferenceInfo', 'callTargetId', callTargetId)
            const localVarPath = `/api/user/call_targets/{callTargetId}/sf_reference_info`
                .replace(`{${"callTargetId"}}`, encodeURIComponent(String(callTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CallTargetSfReferenceInfoApi - functional programming interface
 * @export
 */
export const CallTargetSfReferenceInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CallTargetSfReferenceInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * CallTargetのSF参照値の取得
         * @summary CallTargetのSF参照値の取得
         * @param {number} callTargetId CallTargetID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCallTargetSfReferenceInfo(callTargetId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: SalesforceReferenceInfo; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCallTargetSfReferenceInfo(callTargetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CallTargetSfReferenceInfoApi - factory interface
 * @export
 */
export const CallTargetSfReferenceInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CallTargetSfReferenceInfoApiFp(configuration)
    return {
        /**
         * CallTargetのSF参照値の取得
         * @summary CallTargetのSF参照値の取得
         * @param {number} callTargetId CallTargetID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCallTargetSfReferenceInfo(callTargetId: number, options?: any): AxiosPromise<{ [key: string]: SalesforceReferenceInfo; }> {
            return localVarFp.getCallTargetSfReferenceInfo(callTargetId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CallTargetSfReferenceInfoApi - interface
 * @export
 * @interface CallTargetSfReferenceInfoApi
 */
export interface CallTargetSfReferenceInfoApiInterface {
    /**
     * CallTargetのSF参照値の取得
     * @summary CallTargetのSF参照値の取得
     * @param {number} callTargetId CallTargetID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetSfReferenceInfoApiInterface
     */
    getCallTargetSfReferenceInfo(callTargetId: number, options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: SalesforceReferenceInfo; }>;

}

/**
 * Request parameters for getCallTargetSfReferenceInfo operation in CallTargetSfReferenceInfoApi.
 * @export
 * @interface CallTargetSfReferenceInfoApiGetCallTargetSfReferenceInfoRequest
 */
export interface CallTargetSfReferenceInfoApiGetCallTargetSfReferenceInfoRequest {
    /**
     * CallTargetID
     * @type {number}
     * @memberof CallTargetSfReferenceInfoApiGetCallTargetSfReferenceInfo
     */
    readonly callTargetId: number
}

/**
 * CallTargetSfReferenceInfoApi - object-oriented interface
 * @export
 * @class CallTargetSfReferenceInfoApi
 * @extends {BaseAPI}
 */
export class CallTargetSfReferenceInfoApi extends BaseAPI implements CallTargetSfReferenceInfoApiInterface {
    /**
     * CallTargetのSF参照値の取得
     * @summary CallTargetのSF参照値の取得
     * @param {CallTargetSfReferenceInfoApiGetCallTargetSfReferenceInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallTargetSfReferenceInfoApi
     */
    public getCallTargetSfReferenceInfo(requestParameters: CallTargetSfReferenceInfoApiGetCallTargetSfReferenceInfoRequest, options?: AxiosRequestConfig) {
        return CallTargetSfReferenceInfoApiFp(this.configuration).getCallTargetSfReferenceInfo(requestParameters.callTargetId, options).then((request) => request(this.axios, this.basePath));
    }
}
